module.exports = __webpack_public_path__ + "static/0chain-identity-e6c8894132b942cc4d8a04413dc45d3a.png";